:host {
  --space: #{space()};
  --around: 0;

  display: flex;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  letter-spacing: inherit;

  ::slotted(*) {
    // fix IE11 not wrapping text
    max-width: 100%;
    padding: calc((var(--space) / 2) * var(--around));
    margin: calc((var(--space) / 2) * (1 - var(--around)));
  }

  ::slotted(stzh-show) {
    --show-display: block;
  }

  ::slotted(stzh-vspace),
  ::slotted(stzh-hspace),
  ::slotted(stzh-row),
  ::slotted(stzh-container),
  ::slotted(stzh-section) {
    align-self: stretch;
    flex-grow: 1;
  }
}

:host(:empty) {
  --around: 1;

  width: var(--space);
  height: var(--space);
}

:host([around]:not([around="false"])) {
  --around: 1;
}

/* Border variants */

:host([border="top"]),
:host([border="top-bottom"]) {
  border-top: 1px solid $baseBorderColor;
}

:host([border="bottom"]),
:host([border="top-bottom"]) {
  border-bottom: 1px solid $baseBorderColor;
}

:host([border="left"]),
:host([border="left-right"]) {
  border-left: 1px solid $baseBorderColor;
}

:host([border="right"]),
:host([border="left-right"]) {
  border-right: 1px solid $baseBorderColor;
}

/* Space curve variant */

@each $spaceCurve, $value in $spaceCurves {
  $defaultSize: map-get($value, "size");
  $breakpointSizes: map-get($value, "sizes");

  // :host([curve="#{$spaceCurve}"]) > .stzh-vspace {
  :host([curve="#{$spaceCurve}"]) {
    --space: #{space($defaultSize)};

    @each $breakpoint, $size in $breakpointSizes {
      @include mq($from: $breakpoint) {
        --space: #{space($size)};
      }
    }
  }
}

@mixin spaceProps($breakpoint: null) {
  @each $space, $value in $spaceSizes {
    @if $breakpoint {
      // :host([size-#{$breakpoint}="#{$space}"]) > .stzh-vspace {
      :host([size-#{$breakpoint}="#{$space}"]) {
        @include mq($from: $breakpoint) {
          --space: #{$value};
        }
      }
    } @else {
      // :host([size="#{$space}"]) > .stzh-vspace {
      :host([size="#{$space}"]) {
        --space: #{$value};
      }
    }
  }
}

@include spaceProps();

@each $breakpoint, $size in $breakpoints {
  @include spaceProps($breakpoint);
}

.stzh-space {
  flex-grow: 1;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: calc((var(--space) / -2) * var(--around));
  margin: calc((var(--space) / -2) * (1 - var(--around)));

  &--is-around {
    padding: calc((var(--space) / 2) * var(--around));
    margin: calc((var(--space) / 2) * (1 - var(--around)));
  }

  /* Justify content variants */

  &--justify-center {
    justify-content: center;
  }

  &--justify-end {
    justify-content: flex-end;
  }

  &--justify-between {
    justify-content: space-between;
  }

  &--justify-around {
    justify-content: space-around;
  }

  &--justify-evenly {
    justify-content: space-evenly;
  }

  /* Align items variants */

  &--items-end {
    align-items: flex-end;
  }

  &--items-center {
    align-items: center;
  }

  &--items-baseline {
    align-items: baseline;
  }

  &--items-stretch {
    align-items: stretch;
  }
}
